<div *nzModalTitle>
  Edit Job: {{currentJob?.name}}
</div>

<div>
  <nz-spin [nzSpinning]="loading">
    <form nz-form [formGroup]="jobForm">
      <nz-form-item class="floating-label">
        <nz-form-label nzRequired nzFor="jobName" [nzNoColon]="true">Job Name</nz-form-label>
        <nz-form-control>
          <input type="text" nz-input placeholder="Job Name" id="jobName" required formControlName="name" />
        </nz-form-control>
      </nz-form-item>

      <nz-form-item class="floating-label">
        <nz-form-label nzRequired nzFor="projectId" [nzNoColon]="true">Project Group</nz-form-label>
        <nz-form-control>
          <nz-select nzShowSearch [nzDisabled]="allProjects == null" [nzLoading]="allProjects == null" name="projectId"
            formControlName="projectId">
            @for (project of allProjects; track project) {
              <nz-option [nzValue]="project.id" [nzLabel]="project.name">{{ project.name
              }}</nz-option>
            }
          </nz-select>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item class="floating-label">
        <nz-form-label nzRequired nzFor="basePath" [nzNoColon]="true">Base Path</nz-form-label>
        <nz-form-control nzErrorTip="Base path is a required field!">
          <input type="text" nz-input placeholder="Base Path" id="basePath" required formControlName="basePath" />
        </nz-form-control>
      </nz-form-item>

      @if (currentJob?.originalPath) {
        <nz-form-item class="floating-label">
          <nz-form-label nzFor="originalPath" [nzNoColon]="true">Original Path</nz-form-label>
          <nz-form-control>
            <input type="text" nz-input placeholder="Original Path" id="originalPath" formControlName="originalPath" />
          </nz-form-control>
        </nz-form-item>
      }

      <nz-form-item class="floating-label">
        <nz-form-label nzRequired nzFor="iterations" [nzNoColon]="true">Iterations</nz-form-label>
        <nz-form-control [nzErrorTip]="iterationErrorTpl">
          <input type="number" noScrollNumber nz-input placeholder="Iterations" id="iterations" required
            formControlName="iterations" (ngModelChange)="updateIterationsValidator()" />
        </nz-form-control>
      </nz-form-item>
      <nz-form-item class="floating-label">
        <nz-form-label nzRequired nzFor="iterationsComplete" [nzNoColon]="true">Iterations Complete</nz-form-label>
        <nz-form-control [nzErrorTip]="iterationErrorTpl">
          <input type="number" noScrollNumber nz-input placeholder="Iterations Complete" id="iterationsComplete"
            required formControlName="iterationsComplete" (ngModelChange)="updateIterationsValidator()" />
        </nz-form-control>
      </nz-form-item>

      <!-- template for the various errors in iterations/iterationsCompleted -->
      <ng-template #iterationErrorTpl let-control>
        @if (control.errors?.['required']) {
          Please enter a valid value
        }
        @if (control.errors?.['pattern']) {
          Please enter a positive integer
        }
        @if (control.errors?.['iterationsInvalid']) {
          Completed iterations must not be greater than total iterations!
        }
      </ng-template>


      <nz-form-item class="floating-label">
        <nz-form-label nzFor="job-comment" [nzNoColon]="true">Comments</nz-form-label>
        <nz-form-control>
          <textarea nz-input placeholder="Comments" id="job-comment" [nzAutosize]="{ minRows: 3 }"
          formControlName="comments"></textarea>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item class="floating-label">
        <nz-form-label nzFor="parentJobControl" [nzNoColon]="true">Parent Job</nz-form-label>
        <nz-form-control>
          <nz-select nzShowSearch name="parentJobControl"
            formControlName="parentJob" nzPlaceHolder="Parent Job"
            [compareWith]="compareFn"
            >
            <nz-option nzLabel="No Parent" [nzValue]="null">No Parent</nz-option>
            @for (job of allJobs; track job) {
              <nz-option [nzValue]="job" [nzLabel]="job.name">{{ job.name }}</nz-option>
            }
          </nz-select>
        </nz-form-control>
      </nz-form-item>
      <nz-form-item class="floating-label">
        <nz-form-label nzRequired nzFor="parentJobCPNUMControl" [nzNoColon]="true">Parent Job CPNUM</nz-form-label>
        <nz-form-control [nzErrorTip]="parentCpErrorTpl">
          <input type="number" noScrollNumber nz-input placeholder="Parent Job CPNUM" id="parentJobCPNUMControl"
            required formControlName="parentCpNum" />
        </nz-form-control>
      </nz-form-item>
      <ng-template #parentCpErrorTpl let-control>
        @if (control.errors?.['required']) {
          Please enter a valid value
        }
        @if (control.errors?.['pattern']) {
          Please enter a positive integer
        }
        @if (control.errors?.['cpInvalid']) {
          CPNum must not be greater than Parent Jobs total iterations
        }
      </ng-template>

      <nz-form-item>
        <span nz-checkbox name="isOffshoot" id="isOffshoot" formControlName="isOffshoot">Is Offshoot?</span>
      </nz-form-item>

      <nz-form-item>
        <span nz-checkbox name="isAWS" id="isAWS" formControlName="isAWS">Is AWS?</span>
      </nz-form-item>

      <nz-form-item class="floating-label">
        <nz-form-label nzFor="jobOwner" [nzNoColon]="true">Job Owner</nz-form-label>
        <nz-form-control>
          <nz-select nzShowSearch name="jobOwner" nzPlaceHolder="Owner" formControlName="owner" [compareWith]="compareFn">
            @for (u of allUsers; track u) {
              <nz-option [nzValue]="u" [nzLabel]="u.email"></nz-option>
            }
          </nz-select>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item class="floating-label">
        <nz-form-label nzFor="type" [nzNoColon]="true">Job Type</nz-form-label>
        <nz-form-control>
          <nz-select name="type" nzPlaceHolder="Job Type" formControlName="jobType">
            @for (jt of jobTypes; track jt) {
              <nz-option [nzValue]="jt" [nzLabel]="jt"></nz-option>
            }
          </nz-select>
        </nz-form-control>
      </nz-form-item>
    </form>
  </nz-spin>
</div>

<div *nzModalFooter>
  <div style="display: flex; justify-content: space-between;">
    <div>
      <button nz-button (click)="onReparse()" [disabled]="loading" nzType="primary">Reparse</button>
      <button nz-button (click)="calculateCost()" [disabled]="loading" nzType="link">Calculate Cost</button>
    </div>
    <div>
      <button nz-button (click)="onCancel()" [disabled]="loading">Cancel</button>
      <button nz-button (click)="onSave()" [disabled]="!jobForm.valid || loading" nzType="primary">Save</button>
    </div>
  </div>
</div>